// extracted by mini-css-extract-plugin
module.exports = {"text__title":"Text_text__title__Ib360"};